export default "__VITE_PUBLIC_ASSET__87dc0768__"